import { LocalizationStore } from '@react/constants/historyEvent/localization/utils';

const store: LocalizationStore = new LocalizationStore();

export function registerActionLocalization(
  onRegisterActions: (register: PickOne<LocalizationStore, 'register'>) => void,
): void {
  onRegisterActions(store.register);
}

export function getLocalizedAction(eventAction: string): string {
  return store.get(eventAction);
}
